import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=6518a4d4"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6518a4d4')) {
      api.createRecord('6518a4d4', component.options)
    } else {
      api.reload('6518a4d4', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=6518a4d4", function () {
      api.rerender('6518a4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/tools/Email.vue"
export default component.exports